<template>
  <div>
    <div id="service">
      <div id="mobile-title" class="mobile">{{ $t('tabBar.service') }}</div>
      <div id="title">
        <span id="title-1">{{ $t('service.title1')}}</span>
        <span id="title-2">{{ $t('service.title2')}}</span>
        <br class="mobile" />
        <span id="title-3">{{ $t('service.title3')}}</span>
        <span id="title-4">{{ $t('service.title4')}}</span>
      </div>

      <div id="desc-1">{{ $t('service.desc1') }}</div>
      <div id="desc-2">
        <span>{{ $t('service.features') }}:</span>
        {{ $t('service.desc2')}}
      </div>

      <div id="services-title">
        <span>{{ $t('service.include') }}:</span> 
        {{ $t('service.phoneOrInterview') }}
      </div>

      <div id="service-list">
        <div class="problem" v-for="i in 14">
          <div class="inner">
            <span class="index">{{ `${i})`}}</span>
            {{ $t(`service.problem${i}`)}}
          </div>
        </div>
      </div>
      
      <div id="pricing">
        <div id="pricing-title">{{ $t('service.pricingDetail') }}:</div> 
        <div>{{ $t('service.pricing1')}}</div>
        <br>
        <div>＊{{ $t('service.pricing2')}}</div>
        <div>＊{{ $t('service.pricing3')}}</div>
        <div>＊{{ $t('service.pricing4')}}</div>
      </div>

      <div id="info">
        <div>{{ $t('service.emailInfo') }}</div> 
        <div>1) {{ $t('service.info1')}}</div>
        <div>2) {{ $t('service.info2')}}</div>
        <div>3) {{ $t('service.info3')}}</div>
        <div>4) {{ $t('service.info4')}}</div>
      </div>

      <router-link to="/contact" class="button">
        {{ $t('tabBar.contactUs') }}
      </router-link>

      <div style="clear:both;"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Service',
};
</script>

<style lang="sass" scoped>
  @import "../styles/variables.sass"

  #service
    padding: 60px 100px

    #mobile-title
      font-size: 24px

    @media #{$mobile}
      padding: 30px

    #mobile-title
      color: $sunglow
      text-align: center
      margin-bottom: 35px

    #title
      text-align: center
      font-size: 24px
      white-space: nowrap

      span
        margin: 0 5px
        font-size: 20px
        @media #{$mobile}
          color: $sprout !important

      #title-1
        color: $jaffa

      #title-2
        color: $gulf-stream

      #title-3
        color: $froly

      #title-4
        color: $olivine

    #desc-1
      color: $dusty-gray
      font-size: 14px
      max-width: 425px
      margin: 0 auto
      margin-top: 42px

    #desc-2
      color: $neptune
      font-size: 14px
      max-width: 776px
      margin: 0 auto
      margin-top: 42px

      span
        font-size: 24px

    #services-title
      color: $atomic-tangerine
      max-width: 776px
      font-size: 14px
      margin: 0 auto
      margin-top: 57px
      margin-bottom: 20px
      span
        font-size: 24px

    #service-list
      max-width: 776px
      margin: 0 auto
      display: flex
      flex-wrap: wrap

      .problem
        width: 50%
        margin-bottom: 5px

        .inner
          margin-right: 6px
          padding-top: 3px
          padding-bottom: 3px
          border-width: 2px
          border-style: solid
          color: $dusty-gray
          font-size: 18px

        .index
          width: 40px
          text-align: right
          display: inline-block

        &:nth-child(4n+1), &:nth-child(4n)
          .inner
            border-color: $sinbad

        &:nth-child(4n+2), &:nth-child(4n+3)
          .inner
            border-color: $beauty-brush

        @media #{$mobile}
          width: 100%

          &:nth-child(2n)
            .inner
              border-color: $sinbad

          &:nth-child(2n+1)
            .inner
              border-color: $beauty-brush

    #pricing
      color: $olivine
      max-width: 776px
      margin: 0 auto
      margin-top: 50px
      font-size: 14px

      #pricing-title
        font-size: 24px
        
    #info
      margin: 0 auto
      margin-top: 45px
      color: $fountain-blue
      font-size: 14px
      max-width: 776px

    .button
      background-color: $macaroni-and-cheese
      color: $white
      border: none
      margin-top: 30px

      @media #{$mobile}
        width: 100%

      @media #{$desktop}
        float: right
        width: 154px
        height: 43px

</style>



// WEBPACK FOOTER //
// src/components/Service.vue